import clsx from 'clsx';
import styles from './styles.module.scss';

interface ActionSelectProps {
  className?: string;
  items: { label: string; value: string | number }[];
  onChange: (value: string | number) => void;
  placeholder?: string;
  defaultValue: string | number;
  value?: string | number;
  noSelect?: boolean;
  'data-testid'?: string;
}

export function ActionSelect({
  className,
  items,
  onChange,
  defaultValue,
  value,
  noSelect = false,
  'data-testid': dataTestId,
}: ActionSelectProps) {
  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className={clsx(styles.root, className)}>
      <select
        className={styles.container}
        onChange={e => handleSelect(e)}
        defaultValue={defaultValue}
        value={value}
        data-testid={dataTestId}
      >
        {noSelect && <option value=''>選択してください</option>}
        {items.map((item: { label: string; value: string | number }, key: number) => {
          return (
            <option key={key} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </select>
    </div>
  );
}
